import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { InventoryService } from '../../../services/inventory.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { PrintService } from '../../../services/print.service'

@Component({
	selector: 'app-review-counts',
	templateUrl: './review-counts.component.html',
	styleUrls: ['./review-counts.component.scss'],
})

export class ReviewCountsComponent implements OnInit {
	@Input() filters: any = false;
	@Input() flip: any = false;

	@Output() complete = new EventEmitter <any> ();
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild('print_table_two') printtabletwo: ElementRef;

	items: any = false;
	allItems: any = false; // Store all items for filtering
	filteredItems: any = false; // Filtered items to display
	showCountedOnly: boolean = false;
	subscribed: any = false;
	printlink: any = false;
	fetching = false;
	count_results:any = false
	transno: any = '';
	filename = 'StockCounts';
	constructor(private printService: PrintService, private globalSearchService: GlobalSearchService, private inventoryService: InventoryService) {}

	ngOnInit(): void {

	}

	closeCounts() {
		const continue_on = confirm('Close Counts and adjust stock?');
		if(continue_on) {
			this.inventoryService.closeCounts(this.filters).subscribe( r => {
				if(r.success) {
					this.count_results = r.movements;
					this.transno = r.transno

					this.globalSearchService.showNotification('Stock Adjusted', 'success', 'bottom', 'right');

				}
			})
		}
	}

	clearCounts() {
		if (!this.filters || !this.filters.location) {
			this.complete.emit(true);
			return;
		}

		const proceed = confirm('Clear all counts and frozen sheets for this location?');
		if (!proceed) {
			return;
		}

		this.fetching = true;
		this.inventoryService.clearCounts(this.filters).subscribe((r: any) => {
			this.fetching = false;

			// Reset local state
			this.items = false;
			this.allItems = false;
			this.filteredItems = false;
			this.subscribed = false;
			this.printlink = false;
			this.count_results = false;
			this.transno = '';
			this.filename = 'StockCounts';

			// Notify parent to reset and reload
			this.complete.emit(true);
		});
	}

	ngOnChanges(changes: any) {

		if(this.flip == 'active') {
			this.fetching = true;
			if(this.subscribed) {
				this.subscribed.unsubscribe();
			}
			this.inventoryService.reviewCounts(this.filters).subscribe(r => {
				if(r.success) {
					this.allItems = r.items;
					this.items = r.items;
					this.applyFilter();
					this.printlink = r.printlink;
				}
				this.fetching = false;
				this.count_results = false;
			});
		}
	}


	getTotalFinalQty() {
		let total = 0
		if(this.items) {
			total = this.count_results.reduce(function(accumulator, c) {
				return accumulator + parseFloat(c.adjustment);
			}, 0);
		}
		return total;
	}

	getTotalFinalValue() {
		let total = 0
		if(this.items) {
			const parent = this;
			total = this.count_results.reduce(function(accumulator, c) {
				return accumulator + parent.lineTotal(c);
			}, 0);
		}
		return total;
	}

	applyFilter() {
		if(!this.allItems) {
			this.filteredItems = false;
			this.items = false;
			return;
		}
		
		if(this.showCountedOnly) {
			// Filter to show only items with counts entered
			this.filteredItems = this.allItems.filter(item => {
				const counted = item.counted;
				return counted && counted !== 'No counts entered' && counted !== 'No Adjustment entered' && counted !== '';
			});
		} else {
			this.filteredItems = this.allItems;
		}
		
		this.items = this.filteredItems;
	}

	toggleCountedFilter() {
		this.showCountedOnly = !this.showCountedOnly;
		this.applyFilter();
	}

	getTotalQty() {
		let total = 0
		if(this.items) {
			total = this.items.reduce(function(accumulator, c) {
				return accumulator + parseFloat(c.adjustment);
			}, 0);
		}
		return total;
	}

	getTotalValue() {
		let total = 0
		if(this.items) {
			const parent = this;
			total = this.items.reduce(function(accumulator, c) {
				return accumulator + parent.lineTotal(c);
			}, 0);
		}
		return total;
	}

	exportPdfTwo() {
		const today = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.printtabletwo.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Stock Counts',
			subtitle: 'Created '+today.toLocaleString(),
			landscape: true,
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}
	exportPdf() {
		const today = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Stock Counts',
			subtitle: 'Created '+today.toLocaleString(),
			landscape: true,
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	lineTotal(item: any) {
		// Use price (actualcost/average cost) if available, otherwise fallback to standardcost
		const cost = item.price && item.price > 0 ? item.price : item.standardcost;
		return this.financial(this.financial(cost) * this.financial(item.adjustment))
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}
}
